import styled from "@emotion/styled";

export const Name = styled.span`
  &:hover {
    cursor: pointer;
  }
`;
